export default "__VITE_ASSET__CfHi8$Gf__"